import { FC, useRef } from "react";
import { ItemRendererProps } from "./types";
import { Column, Row } from "../../../components/containers";
import { WidgetRef } from "../../../types/widget";
import {
  AlignItems,
  JustifyContent,
} from "../../../components/containers/types";
import { useItemWidgetResize } from "./hooks";
import { usePopupStore, useThemeStore } from "../../../stores";
import SelectComponents from "./select-components";
import { Heading } from "../../../components/typography";
import ItemWidgetController from "./item-widget-controller";

const GAP_SIZE = 10;

const ItemRenderer: FC<ItemRendererProps> = ({ item, edit }) => {
  const { widgets } = item;

  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const theme = useThemeStore((s) => s.theme);

  const conRef = useRef<HTMLDivElement>(null);
  const refs = useRef<(WidgetRef | null)[]>([]);

  useItemWidgetResize({ conRef, refs, widgets, gapSize: GAP_SIZE });

  const onConClick = (): void => {
    if (!edit) return;
    setPopupBody(<SelectComponents item={item} />);
  };

  return (
    <Row
      containerRef={conRef}
      gap={GAP_SIZE}
      style={styles.container}
      alignItems={AlignItems.Initial}
      props={{ onClick: onConClick }}
    >
      {widgets.length ? (
        widgets.map((widget, idx) => (
          <div
            key={widget.id}
            style={{
              flex: widget.flex,
              ...styles.widgetContainer,
            }}
            ref={(ref) => {
              if (idx === 0) refs.current = [];
              refs.current.push(ref);
            }}
          >
            <widget.Component />
            <ItemWidgetController
              item={item}
              widget={widget}
              edit={edit || false}
            />
          </div>
        ))
      ) : edit ? (
        <Column
          style={{ ...styles.placeholder, border: `1px solid ${theme.icon}` }}
          justifyContent={JustifyContent.Center}
        >
          <Heading color={theme.textOnOverlay}>
            برای افزودن ویجت کلیک کنید
          </Heading>
        </Column>
      ) : (
        <></>
      )}
    </Row>
  );
};

export default ItemRenderer;

const styles: Record<string, React.CSSProperties> = {
  container: {
    marginBottom: 10,
  },

  widgetContainer: {
    display: "flex",
    alignItems: "initial",
    position: "relative",
    width: "100%",
  },

  placeholder: {
    width: "100%",
    height: 150,
    borderRadius: 15,
  },
};
